var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M29.6 52.13c7.3 0 13.2-.3 13.2-.66 0-.37-5.9-.67-13.2-.67-7.29 0-13.2.3-13.2.67 0 .36 5.91.66 13.2.66z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 51.87c10.75 0 19.47-8.48 19.47-18.94C49.07 22.48 40.35 14 29.6 14c-10.75 0-19.47 8.48-19.47 18.93 0 10.46 8.72 18.94 19.47 18.94z",
    fill: "#A7E2F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.13 14h-.8L28 15.33l-.4.8v2c0 .67-.4 1.07-1.07 1.2-.66-.13-1.2.4-1.33 1.07v1.87c0 .26 0 .66-.27.8l-.8.53c-.53-.13-1.06.4-1.2.93 0 .67.54 1.2 1.2 1.2h.8c.14 0 .27 0 .27.27l8.27 7.6c.13.27.53.4.8.4H48c.27 0 .53-.13.8-.4v-1.33A18.52 18.52 0 0030.27 14h-.14zM20.67 34.93h-.54c-.8.14-1.46-.53-1.6-1.33v-1.07c0-.4-.13-.8-.4-1.06l-1.06-.4h-2.4l-1.07-.27-1.6-1.6c-.27-.27-.67-.4-1.07-.4h-.4a21.7 21.7 0 00-.4 4.13 18.7 18.7 0 0011.74 17.34c.26-.27.4-.67.4-1.07V36.4c-.14-.8-.8-1.47-1.6-1.47zM47.73 38.93l-8-.4h-.4l-3.86 3.6h-.14v.54c0 .26 0 .26.14.4l3.86 4.13c0 .13.14.27.14.4s-.14.27-.14.4l-1.86 2c4.4-1.87 8-5.47 10-9.87.13-.53.26-1.06.53-1.46l-.27.26z",
    fill: "#77D9F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.82 6.87l-3.35 13.86.65.16 3.35-13.87-.65-.15z",
    fill: "#2E4369"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13.33h-1.87a21.39 21.39 0 01-8.53-2.26l-1.6-.94 3.07-2.26L30.13 4l1.07.53a19.63 19.63 0 008.67 2.4h1.73l-1.6 6.4z",
    fill: "#485CC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.33 31.4l-3.71 13.77.64.17 3.72-13.77-.65-.18z",
    fill: "#2E4369"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.47 37.47h-1.74a19.24 19.24 0 01-8.53-2.54L29.6 34l3.07-2-.8-4 1.2.67a21.77 21.77 0 008.53 2.53h1.6l-1.73 6.27z",
    fill: "#485CC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 22.87l-.28 14.27h.66l.28-14.26h-.66z",
    fill: "#2E4369"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 29.33l-1.87.4c-2.93.54-6 .4-8.8-.4L4.8 28.8l2.53-2.93-1.73-3.6 1.07.4c2.93.8 6 1.06 8.93.53l1.73-.4-.13 6.53z",
    fill: "#485CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.29,
    y1: 51.47,
    x2: 42.6,
    y2: 51.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.315a42993e89343b9841a23148326955.svg";
export { ForwardRef as ReactComponent };